<template>
  <div>
    <div>
      <el-form ref="form">
        <el-space wrap>
          <el-form-item label="板块:">
            <el-select v-model="obj.selectedBlockValue" @change="handleSelectChange" style="width:120px" disabled="true">
              <el-option v-for="item in obj.selectBlockList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="期间:">
            <el-select v-model="obj.interval" @change="handleSelectChange" style="width:110px">
              <el-option v-for="item in obj.intervalList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="指标:">
            <el-select v-model="obj.indicators" placeholder="请选择" @change="handleSelectChange" style="width:170px">
              <el-option-group v-for="group in obj.indicatorsList" :key="group.label" :label="group.label">
                <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value" />
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="形态:">
            <el-select v-model="obj.patterns" placeholder="请选择" @change="handleSelectChange" style="width:120px">
              <el-option-group v-for="group in obj.patternsList" :key="group.label" :label="group.label">
                <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value" />
              </el-option-group>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="自定义:">
            <el-select v-model="obj.customize" placeholder="请选择" @change="handleCustomizeChange" style="width:200px">
              <el-option-group v-for="group in obj.customizeList" :key="group.label" :label="group.label">
                <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value" />
              </el-option-group>
            </el-select>
            <el-select v-model="obj.symbols" placeholder="符号" style="width:80px">
              <el-option v-for="item in obj.symbolsList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-input-number v-model="obj.amount" placeholder="数量" style="width: 160px;">
            </el-input-number>
          </el-form-item> -->
          <el-form-item label="">
            <el-button type="primary" @click="handleSubmit">
              <el-icon class="el-input__icon">
                <refresh />
              </el-icon>
            </el-button>
          </el-form-item>
        </el-space>
      </el-form>
    </div>
    <el-tag type="warning" size="small" v-if="obj.date !== ''">数据截至到 {{ obj.date }}</el-tag>
    <div>
      <el-table :data="obj.dataList" height="100%" style="width: 100%" empty-text=" "
        :style="'height:' + (this.$store.state.windowHeight - 200) + 'px'" :cell-style="cellStyle"
        @row-click="handleRowClick">
        <el-table-column fixed label="序号" prop="no" width="60px" align="right" />
        <el-table-column fixed label="名称" prop="name" width="140px" align="right" sortable />
        <el-table-column label="代码" prop="symbol" width="100px" align="right" sortable />
        <el-table-column label="最新" prop="close" width="80px" align="right" />
        <el-table-column label="涨跌" prop="chg" width="90px" align="right" :sort-method="customStrSort" sortable />
        <el-table-column label="涨跌幅" prop="chgPct" width="90px" align="right" :sort-method="customPctSort" sortable />
        <el-table-column label="开盘" prop="open" width="80px" align="right" />
        <el-table-column label="最低" prop="low" width="80px" align="right" />
        <el-table-column label="最高" prop="high" width="80px" align="right" />
        <el-table-column label="成交量" prop="vol" width="90px" align="right" :sort-method="customVolSort" sortable />
        <el-table-column label="持仓量" prop="opi" width="90px" align="right" :sort-method="customOpiSort" sortable />
        <el-table-column label="增仓" prop="opiChg" width="80px" align="right" sortable />
        <el-table-column label="前结" prop="preSett" width="80px" align="right" />
        <el-table-column label="前收" prop="preClose" width="80px" align="right" />
        <el-table-column label="趋势度" prop="trend" width="100px" align="right" sortable/>
        <el-table-column label="振幅" prop="amplitude" width="80px" align="right" :sort-method="customAmplitudeSort" sortable/>
        <el-table-column label="成交额" prop="turnover" width="90px" align="right" :sort-method="customTurnoverSort" sortable/>
      </el-table>
    </div>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { http } from '../util/http'
import { bigNumberTransform, formatDecimalPoint } from '../util/base'
import { ElMessage } from 'element-plus'
export default {
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const chartDomRef = ref()
    const router = useRouter()
    const store = useStore()
    const obj = reactive({
      selectBlockList: [
        {
          value: 'all',
          label: '全部'
        }
      ],
      selectedBlockValue: 'all',
      intervalList: [
        {
          value: '1',
          label: '最近 1日'
        },
        {
          value: '2',
          label: '最近 2日'
        },
        {
          value: '3',
          label: '最近 3日'
        },
        {
          value: '4',
          label: '最近 4日'
        },
        {
          value: '5',
          label: '最近 5日'
        },
        {
          value: '10',
          label: '最近 10日'
        },
        {
          value: '20',
          label: '最近 20日'
        },
        {
          value: '30',
          label: '最近 30日'
        },
        {
          value: '40',
          label: '最近 40日'
        },
        {
          value: '50',
          label: '最近 50日'
        },
        {
          value: '60',
          label: '最近 60日'
        },
        // {
        //   value: '0',
        //   label: '全部'
        // }
      ],
      interval: '1',
      indicatorsList: [
        {
          label: '',
          options: [
            {
              value: '',
              label: '无'
            }
          ],
        },
        {
          label: 'MA指标',
          options: [
            {
              value: 'MA_2_LONG',
              label: 'MA多头排列(2均线)'
            },
            {
              value: 'MA_2_SHORT',
              label: 'MA空头排列(2均线)'
            },
            // {
            //   value: 'MA_3_LONG',
            //   label: 'MA多头排列(3均线)'
            // },
            // {
            //   value: 'MA_3_SHORT',
            //   label: 'MA空头排列(3均线)'
            // },
            {
              value: 'MA_LONG',
              label: 'MA多头排列(3均线)'
            },
            {
              value: 'MA_SHORT',
              label: 'MA空头排列(3均线)'
            },
            {
              value: 'MA_CROSSUP',
              label: 'MA金叉'
            },
            {
              value: 'MA_CROSSDOWN',
              label: 'MA死叉'
            },
            {
              value: 'Up_MA1',
              label: 'MA5上方收盘'
            },
            {
              value: 'Down_MA1',
              label: 'MA5下方收盘'
            },
            {
              value: 'Up_MA2',
              label: 'MA10上方收盘'
            },
            {
              value: 'Down_MA2',
              label: 'MA10下方收盘'
            },
            {
              value: 'Up_MA3',
              label: 'MA20上方收盘'
            },
            {
              value: 'Down_MA3',
              label: 'MA20下方收盘'
            }
          ],
        },
        {
          label: 'BOLL指标',
          options: [
            {
              value: 'UP_BOLL_MID',
              label: '布林中轨上方收盘'
            },
            {
              value: 'DOWN_BOLL_MID',
              label: '布林中轨下方收盘'
            },
            {
              value: 'BOLL_CROSSUP_MID',
              label: '突破布林中轨'
            },
            {
              value: 'BOLL_CROSSDOWN_MID',
              label: '跌破布林中轨'
            },
          ],
        },
        {
          label: 'MACD指标',
          options: [
            {
              value: 'MACD_CROSSUP',
              label: 'MACD金叉'
            },
            {
              value: 'MACD_CROSSDOWN',
              label: 'MACD死叉'
            },
            {
              value: 'MACD_RED',
              label: 'MACD红柱'
            },
            {
              value: 'MACD_GREEN',
              label: 'MACD绿柱'
            },
          ],
        },
        {
          label: 'KDJ指标',
          options: [
            {
              value: 'KDJ_CROSSUP',
              label: 'KDJ金叉'
            },
            {
              value: 'KDJ_CROSSDOWN',
              label: 'KDJ死叉'
            },
            // {
            //   value: '5-1',
            //   label: '多头增仓'
            // },
            // {
            //   value: '5-2',
            //   label: '空头增仓'
            // }
          ],
        },
      ],
      indicators: '',
      patternsList: [
        {
          label: '',
          options: [
            {
              value: '',
              label: '无'
            }
          ],
        },
        {
          label: '三k线组合',
          options: [
            {
              value: 'MorningStar',
              label: '早晨之星'
            },
            {
              value: 'EveningStar',
              label: '黄昏之星'
            },
          ],
        },
        {
          label: '两k线组合',
          options: [
            {
              value: 'EngulfingUp',
              label: '看涨吞没'
            },
            {
              value: 'EngulfingDown',
              label: '看跌吞没'
            },
            {
              value: 'Piercing',
              label: '向上刺透'
            },
            {
              value: 'DarkCloudCover',
              label: '乌云压顶'
            },
          ],
        },
        {
          label: '单k线模式',
          options: [
            {
              value: 'MarubozuUp',
              label: '实体饱满阳'
            },
            {
              value: 'MarubozuDown',
              label: '实体饱满阴'
            },
            {
              value: 'Hammer',
              label: '锤子形态'
            },
            {
              value: 'ShootingStar',
              label: '流星形态'
            },
            {
              value: 'Dragonfly',
              label: '蜻蜓十字'
            },
            {
              value: 'Gravestone',
              label: '墓碑十字'
            },
            {
              value: 'Dojistar',
              label: '十字星'
            },
          ],
        },
        {
          label: '其他',
          options: [
            {
              value: 'up',
              label: '收阳'
            },
            {
              value: 'down',
              label: '收阴'
            },
            {
              value: '2up',
              label: '二连阳'
            },
            {
              value: '2down',
              label: '二连阴'
            },
            {
              value: '3up',
              label: '三连阳'
            },
            {
              value: '3down',
              label: '三连阴'
            },
          ],
        },
      ],
      patterns: '',
      customizeList: [
        {
          label: '',
          options: [
            {
              value: '',
              label: '无'
            }
          ],
        },
        {
          label: '常用项目',
          options: [
            {
              value: 'chg2Pct',
              label: '涨跌幅(收盘价)(%) (均值)'
            },
            {
              value: 'opiCapitalChg',
              label: '资金净流入 (合计)'
            },
            {
              value: 'opiCapitalChgPct',
              label: '资金净流入比(%) (均值)'
            },
            {
              value: 'turnoverChg',
              label: '成交额增量 (合计)'
            },
            {
              value: 'turnoverChgPct',
              label: '成交额增量比(%) (均值)'
            },
            {
              value: 'amplitude',
              label: '振幅(%) (均值)'
            },
          ],
        },
        {
          label: '衍生项目',
          options: [
            {
              value: 'trend',
              label: '趋势度 (均值)'
            },
            {
              value: 'volOpi',
              label: '投机度 (均值)'
            },
          ],
        },
        {
          label: '金融项目',
          options: [
            {
              value: 'rtn',
              label: '收益率 (均值)'
            },
            {
              value: 'std',
              label: '波动率 (均值)'
            },
            {
              value: 'sharp',
              label: '夏普比'
            },
            {
              value: 'var',
              label: 'VaR (95%置信区间)'
            },
          ],
        },
      ],
      customize: '',
      symbolsList: [
        {
          value: 'gt',
          label: '>'
        },
        {
          value: 'e',
          label: '='
        },
        {
          value: 'lt',
          label: '<'
        },

      ],
      symbols: '',
      amount: 0,
      dataList: [],
      date: ''
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      renderView()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      setStore()
    })

    // 渲染画面
    const renderView = () => {
      // 是否存在缓存
      if (store.state.technicalData === '') {
        // 无缓存，从后台请求数据
        // requestData()
      } else {
        // 有缓存，设定页面状态
        getStore()
      }
    }

    // 后台获取数据
    const requestData = () => {
      let formData = new FormData()
      formData.append("interval", obj.interval)
      formData.append("indicators", obj.indicators)
      formData.append("patterns", obj.patterns)
      // formData.append("customize", obj.customize)
      // formData.append("symbols", obj.symbols)
      // formData.append("amount", obj.amount)
      http({
        url: `/technical`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data)
        if (res.data.data.length === 0) {
          ElMessage.info('没有符合条件的合约')
        }
        processData(res.data.data)
        setStore()
      })
    }

    // 处理数据
    const processData = (data) => {
      let no = 1
      data.forEach((item) => {
        obj.date = item.date
        if (item.chgPct !== "-") {
          item.chgPct = (item.chgPct * 100).toFixed(2) + '%'
          item.volForSort = parseFloat(item.vol)
          item.opiForSort = parseFloat(item.opi)
          item.vol = bigNumberTransform(parseFloat(item.vol))
          item.opi = bigNumberTransform(parseFloat(item.opi))
          item.chg = formatDecimalPoint(parseFloat(item.chg), item.symbol)
          item.close = formatDecimalPoint(parseFloat(item.close), item.symbol)
          item.open = formatDecimalPoint(parseFloat(item.open), item.symbol)
          item.low = formatDecimalPoint(parseFloat(item.low), item.symbol)
          item.high = formatDecimalPoint(parseFloat(item.high), item.symbol)
          item.preSett = formatDecimalPoint(parseFloat(item.preSett), item.symbol)
          item.preClose = formatDecimalPoint(parseFloat(item.preClose), item.symbol)
          item.trend = parseFloat(item.trend.toFixed(2))
          item.amplitude = (item.amplitude * 100).toFixed(2) + '%'
          item.turnoverForSort = parseFloat(item.turnover)
          item.turnover = bigNumberTransform(parseFloat(item.turnover))
        }
        item.no = no
        no++
      })
      obj.dataList = data
    }

    // 保存Store
    const setStore = () => {
      var storeObj = {
        'interval': obj.interval,
        'indicators': obj.indicators,
        'patterns': obj.patterns,
        'customize': obj.customize,
        'symbols': obj.symbols,
        'amount': obj.amount,
        'dataList': obj.dataList,
        'date': obj.date
      }
      store.commit('setTechnicalData', storeObj)
    }

    // 获取Store
    const getStore = () => {
      obj.interval = store.state.technicalData.interval
      obj.indicators = store.state.technicalData.indicators
      obj.patterns = store.state.technicalData.patterns
      obj.customize = store.state.technicalData.customize
      obj.symbols = store.state.technicalData.symbols
      obj.amount = store.state.technicalData.amount
      obj.dataList = store.state.technicalData.dataList
      obj.date = store.state.technicalData.date
    }

    // 重置画面
    const resetView = () => {
      obj.interval = '1'
      obj.indicators = ''
      obj.patterns = ''
      obj.customize = ''
      obj.symbols = ''
      obj.amount = '0'
      obj.dataList = []
      obj.dataList = ''
    }

    /**
     * 事件处理区域
     */

    // 下拉框选择事件
    const handleSelectChange = (e) => {
      // requestData()
    }

    // 下拉框Customize选择事件
    const handleCustomizeChange = (e) => {
      if (obj.customize === '') {
        obj.symbols = ''
        obj.amount = 0
      }
    }

    // 表格行点击事件
    const handleRowClick = (row) => {
      let name = row.name
      store.commit('setCurrentContract', name)
      router.push(`/candlestick?name=${name}`)
    }

    // 按钮提交事件
    const handleSubmit = () => {
      if (!formCheck()) {
        return
      }
      requestData()
    }

    // 表单Check处理
    const formCheck = () => {
      if (obj.indicators.trim() === '' && obj.patterns.trim() === '' &&
        (obj.customize.trim() === '' || obj.symbols.trim() === '')) {
        ElMessage.error('请选择或输入条件')
        return false
      }
      return true
    }

    /**
     * 样式设置区域
     */

    // 表格单元格样式
    const cellStyle = (row, column, rowIndex, columnIndex) => {
      if (row.row.chg > 0 && row.columnIndex === 4) {
        return { color: 'red' }
      } else if (row.row.chg < 0 && row.columnIndex === 4) {
        return { color: 'green' }
      }
      if (row.row.chgPct.toString().replace('%', '') > 0 && row.columnIndex === 5) {
        return { color: 'red' }
      } else if (row.row.chgPct.toString().replace('%', '') < 0 && row.columnIndex === 5) {
        return { color: 'green' }
      }
      if (row.row.open > row.row.preSett && row.columnIndex === 6) {
        return { color: 'red' }
      } else if (row.row.open < row.row.preSett && row.columnIndex === 6) {
        return { color: 'green' }
      }
      if (row.row.low > row.row.preSett && row.columnIndex === 7) {
        return { color: 'red' }
      } else if (row.row.low < row.row.preSett && row.columnIndex === 7) {
        return { color: 'green' }
      }
      if (row.row.high > row.row.preSett && row.columnIndex === 8) {
        return { color: 'red' }
      } else if (row.row.high < row.row.preSett && row.columnIndex === 8) {
        return { color: 'green' }
      }
      if (row.row.close > row.row.preSett && row.columnIndex === 3) {
        return { color: 'red' }
      } else if (row.row.close < row.row.preSett && row.columnIndex === 3) {
        return { color: 'green' }
      }
      if (row.row.trend > 0 && row.columnIndex === 14) {
        return { color: 'red' }
      } else if (row.row.trend < 0 && row.columnIndex === 14) {
        return { color: 'green' }
      }
    }

    // 表格排序(文字型的数字列)
    const customStrSort = (a, b) => {
      return parseFloat(a.chg) - parseFloat(b.chg)
    }

    // 表格排序(带百分号的数字列)
    const customPctSort = (a, b) => {
      return parseFloat(a.chgPct.replace('%', '')) - parseFloat(b.chgPct.replace('%', ''))
    }

    // 表格排序(带金额单位的数字列)
    const customVolSort = (a, b) => {
      return a.volForSort - b.volForSort
    }

    // 表格排序(带金额单位的数字列)
    const customOpiSort = (a, b) => {
      return a.opiForSort - b.opiForSort
    }

    // 表格排序(带金额单位的数字列)
    const customTurnoverSort = (a, b) => {
      return a.turnoverForSort - b.turnoverForSort
    }

    // 表格排序(带百分号的数字列)
    const customAmplitudeSort = (a, b) => {
      return parseFloat(a.amplitude.replace('%', '')) - parseFloat(b.amplitude.replace('%', ''))
    }

    return {
      obj,
      chartDomRef,
      store,
      handleSelectChange,
      handleCustomizeChange,
      handleRowClick,
      handleSubmit,
      cellStyle,
      customStrSort,
      customPctSort,
      customVolSort,
      customOpiSort,
      customAmplitudeSort,
      customTurnoverSort,
    }
  }
}
</script>
<style lang="scss" scoped></style>
